module.exports = __webpack_public_path__ + "img/demo-1.b7d6e5ab.png";